import React from 'react';
import { useTranslation } from 'react-i18next';

import HeaderLabel from '../header-label/HeaderLabel';

function ProjectRequestHeader() {
  const { t } = useTranslation('projectRequest');

  return <HeaderLabel>{t('requestNewProject')}</HeaderLabel>;
}

export default ProjectRequestHeader;
